<template>
	<action-panels></action-panels>
	<template v-if="menu && menu.groups">
		<side-bar-menu-group v-for="g in menu.groups" :group="g" :key="g.name"></side-bar-menu-group>
	</template>
	<history-box></history-box>
</template>

<script setup lang="ts">
/*******
 	This is component that is used only in JSP pages
 */
import type {SideMenu} from "@t/ui/Menu.ts";
import type {History, HistoryObject} from "@t/meta/History.ts";
import SideBarMenuGroup from "@/ui/mouse/SideBarMenuGroup.vue";
import type {FormEnvironment} from "@fd/Types.ts";
import {injectEnv} from "@fd/Environment.ts";
import {onMounted} from "vue";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import HistoryBox from "@/ui/mouse/HistoryBox.vue";
import {ActionPanelInstance} from "@t/ui/ActionPanel.ts";
import ActionPanels from "@/ui/action-panel/ActionPanels.vue";

const props = defineProps<{
	menu: SideMenu,
	history: History,
	panels?: ActionPanelInstance<any>[]
}>();
const env:FormEnvironment = injectEnv();
const navStore = useNavigationStore();

onMounted(() => {
	//console.log("Got history "+JSON.stringify(props.history));
	navStore.setSideMenu(props.menu);
	if (props.history) navStore.setHistoryItems(props.history.items);
	if (Array.isArray(props.panels)) navStore.setActionPanels(props.panels);
});

</script>

<style>
#side_menu_container {
	display: flex;
	flex-direction: column;
	row-gap: 16px;
	box-sizing: border-box;
}
</style>